window.departmentService = {

    async getDepartment(params = { id: 0 }) {

        try {

            const response = await fetch(window.appConfig.routes.getDepartment, {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': window.appConfig.csrfToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });

            if (response.ok) {
                return await response.json();
            }

            return { status: 500, data: null, detail: ['Bad response'] };

        } catch (error) {

            throw error;

        }

    }

};